
import { useState } from 'react'

import tableTurnImg from "../../assets/images/shop/table-turn.png"
import leftCoinImg from "../../assets/images/shop/coin-left.png"
import rightCoinImg from "../../assets/images/shop/coin-right.png"
import tableTurnSmallImg from "../../assets/images/cards/cardTurntable.png"
import handImg from "../../assets/images/myInvites/finger.png"
import ButtonComp from '../../components/common/ButtonComp.js';
import flowerImg from "../../assets/images/shop/flower.png"

import BuyComp from '../../components/common/BuyComp.js';
import { changeTurntableDialog } from '../../store/module/settins.js';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next'


interface PropType {
    dataList: any[]
}
const Draw = ({ dataList }: PropType) => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    return (

        <div className='relative mt-[20px]'>
            <div className="absolute top-[20px] w-[15px] h-[310px] bg-gradient-to-t to-[#244C1E] from-[#132D2B]  rounded-tr-[20px] border-r border-[#376E89] "></div>
            <div className="absolute top-[20px] right-0 w-[15px] h-[310px] bg-gradient-to-t rounded-tl-[20px] border-l border-[#376E89] to-[#376196] from-[#132D2B]"></div>
            <div className='px-[30px] relative bg-cover bg-no-repeat h-[184px] w-full '>
                <div className='border border-[#00E49F] h-[138px] flex px-5 items-center justify-center bg-gradient-to-t to-[#347F7A] from-[#132D2B] rounded-tl-[20px] rounded-tr-[20px]'>

                    <p className='text-[#00D6E4] text-[14px] w-[160px] text-shadow-lg text-left mr-2'>{t("shop.cardraw")}</p>
                    <div className='w-[100px] h-[100px] flex justify-center items-center relative' style={{ filter: 'drop-shadow(0px 0px 40px #000)' }}>
                        <img className='w-[100px] animate-rotate' src={tableTurnImg} alt="" />
                        <img className='absolute right-0 bottom-0 w-[33px] ' src={rightCoinImg} alt="" />
                        <img className='absolute left-0 bottom-0 w-[33px] ' src={leftCoinImg} alt="" />
                        <img className='absolute left-[50%] top-[50%] bottom-0 w-4 animate-rotate-turntable' src={handImg} alt="" />
                    </div>
                </div>
            </div>
            <div className='w-full grid grid-cols-1 gap-4 absolute top-[135px] rounded-tr-[40px] rounded-tl-[40px] px-4 pt-[30px] bg-gradient-to-t from-[#092524] to-[#1C514E]'>
                {
                    dataList.map((item: any, index) => {
                        return (
                            <div key={index}>
                                {
                                    item.length > 0 &&
                                    <div key={index} className='relative w-full flex items-center justify-between px-4 py-2 h-[90px] rounded-[20px] special-class '>
                                        <div>
                                            <div className={`${item[0].discount <= 0 ? 'hidden' : ''} w-8 absolute -top-1 -left-0 flex justify-center items-center`}>
                                                <img className='w-8' src={flowerImg} alt="" />
                                                <span className='absolute text-xs text-white'>{item[0].discount}%</span>
                                            </div>

                                            <div className='flex flex-1 items-center justify-center'>
                                                <img className='w-12 mr-2' src={tableTurnSmallImg} alt="" />
                                                <p className='text-sm text-white font-[900]'><span className='text-transparent bg-clip-text bg-gradient-to-r from-[#00E49F] to-[#54ADFF]'>{item[0].count} </span>{t("shop.cardchanc")}</p>
                                            </div>
                                        </div>
                                        <div className='w-[132px]'>
                                            <BuyComp title={t("shop.cardchanc")} info={item}></BuyComp>
                                        </div>
                                    </div>
                                }
                            </div>

                        )
                    })
                }
            </div>

        </div>


    )
}


export default Draw;